import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class CenterStudyLanguageService {

  constructor(private _http: HttpClient) {
  }

  get(id: number) {
    return this._http.get<any>('api/a/center/study/language/' + id);
  }

  getList(params: any) {
    return this._http.post<any>('api/a/center/study/language/all', params);
  }

  save(dictionary: any) {
    return this._http.post<any>('api/a/center/study/language/save', dictionary);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/user/services/center-study-language.service.ts